import React, { useEffect, useState } from "react";
import { SpecializationsListViewModel } from "./SpecializationsListViewModel.csharp";

export const SpecializationsList: React.FC<SpecializationsListViewModel> = ({
  heading,
  specializationLinks,
  containerUrl,
}) => {
  const [linksToShow, setLinksToShow] = useState(9);

  useEffect(() => {
    if (window.innerWidth < 952) {
      setLinksToShow(6);
    }
  }, []);

  const showMoreLinks = () => {
    setLinksToShow(linksToShow + 6);
  };

  const hasMore = linksToShow < specializationLinks.length;

  return (
    <div className="offset-lg-up">
      <h2 className="link-list--simple-top-heading mb-lg-3">{heading}</h2>
      <ul
        id="servicesList"
        className={"ul link-list link-list--simple mb-3 row"}
        aria-live="polite"
      >
        {specializationLinks.slice(0, linksToShow).map((l, i) => (
          <li
            key={i}
            className="link-list--simple__item col-sm-9 col-lg-6 mb-1 mb-lg-2 pt-1"
          >
            <a
              href={l.url}
              className="link-list--simple__item-link theme-border"
            >
              {l.title}
            </a>
          </li>
        ))}
      </ul>

      {hasMore && (
        <button
          className="btn-link link-list--simple__load-more mb-3"
          onClick={showMoreLinks}
          aria-controls="servicesList"
        >
          Vis flere tjenester
        </button>
      )}

      <div className="mb-5">
        <a className="read-more" href={containerUrl}>
          Alle tjenester A-&Aring;
        </a>
      </div>
    </div>
  );
};
